import { bind } from 'decko'
import { LiveElement } from 'live-node-list'

export default class CurrencySwitcher {

  /**
   * @type {LiveElement}
   */
  currencySwitcherForm = new LiveElement('.currency-switcher form')

  /**
   *
   */
  constructor() {
    if (!this.currencySwitcherForm.item) {
      return
    }

    this.registerListeners()
  }

  @bind
  registerListeners() {
    const select = this.currencySwitcherForm.item.querySelector('select')

    select.addEventListener('change', e => {
      this.currencySwitcherForm.item.submit()
    })
  }
}
